import React from 'react';

/** Minimal horse head outline — used where Heroicons has no horse glyph. */
export default function HorseSilhouetteIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4 20v-2.5c0-1 .4-2 1.1-2.7L9 11.2V9.5C9 6.5 11.2 4 14.2 4c1.2 0 2.3.4 3.2 1.1l1.1.9"
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 6c1.2 1.5 1.8 3.3 1.8 5.2V14l2 3.5H18l-1.2-2.4"
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 20H4M12.5 14.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z"
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
      />
      <path
        d="M6.5 9.5 5 8M16 8.5l1.5-1"
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
      />
    </svg>
  );
}
